import * as React from "react";

import {faceIconColor} from "@repo/auth-shared";

export const ClasslinkIcon = ({
    disabled = false,
    ariaHidden,
}: {
    disabled?: boolean;
    ariaHidden?: boolean;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    return (
        <svg
            viewBox="0 0 136.43 97.36"
            fill={fadeFn("#0a4d7f")}
            aria-hidden={ariaHidden}
        >
            <g>
                <path
                    className="cls-1"
                    d="M39.73,57.57h-.02c-5.31,6.05-.03,8.93-.03,8.93,.18,.1,.39,.18,.6,.25-.81-3.2-.91-6.28-.55-9.18Z"
                />
                <path
                    className="cls-1"
                    d="M74.35,65.42c-4.15,2.82-9.01,12.23-9.01,12.23l-2.51-.03c1.64-3.59,2.68-6.56,3.3-9.01-.64,.22-1,.32-1,.32-5,1.7-10.08,2.6-14.59,2.65,4.75,7.08,13.39,8.34,13.39,8.34,12.15,1.63,21.37-5.02,26.32-9.84-10.23-5.56-15.9-4.67-15.9-4.67Z"
                />
                <path
                    className="cls-1"
                    d="M113.72,39.28s8-19.91-10.32-33.55c0,0-29.35-19.3-45.75,12.93,0,0-11.74-11.72-26.21-2.63-12.38,7.78-10.32,18.29-9.21,23.55,0,0-23.37,6.86-22.17,31.73,.89,18.53,18.78,24.1,25.75,25.57,1.53,.32,3.08,.47,4.64,.47H107.14c1.51,0,3.01-.14,4.48-.44,7.01-1.42,25.14-6.99,24.8-26.66-.42-24.36-22.71-30.97-22.71-30.97Zm-50.37,44.63c-15.53-.18-21.04-11.82-21.04-11.82-.31-.62-.59-1.23-.85-1.85-4.27-1.58-6.78-4.59-6.2-9.05,.59-4.52,5.66-8.93,5.66-8.93h0c2.95-9.13,9.59-15.38,9.59-15.38,0,0,5.58-5.95,11.65-8.99l10.57,1.64c-23.96,9.75-25.19,29.94-25.19,29.94-.16,3.03,.22,5.63,.93,7.84,1.79-.13,3.09-.33,3.09-.33,5.92-.91,11.02-2.5,15.34-4.39-.14-3.97-1.96-4.96-1.96-4.96,0,0-2.18-2.48-11.1-3.93l.85-1.19s4.42,.99,9.41,.03c5.44-1.04,10.42-4.77,15.95-12.37l2.68-.12c-5.43,7.2-5.8,12.63-4.89,16.21,5.41-4.02,7.96-7.56,7.96-7.56,9.75-13.63-3.8-11.56-3.8-11.56l4.08-4.81c20.71,4.49,1.7,23.19,1.7,23.19-2.2,2.26-4.64,4.21-7.08,5.86,.36,.38,3.95,4.07,10.83,7.38,1.81-1.92,2.77-3.32,2.77-3.32l2.73,.49c-16.18,19.44-33.69,17.98-33.69,17.98Zm7.36-38.84c-.1,2.28-1.98,4.12-4.27,4.17-2.52,.05-4.56-2.03-4.45-4.55,.1-2.28,1.98-4.12,4.27-4.17,2.52-.05,4.55,2.03,4.45,4.55Z"
                />
            </g>
        </svg>
    );
};
